interface ErrorBannerProps {
  message?: string | null;
}

export function ErrorBanner({ message }: ErrorBannerProps) {
  if (!message) return null;
  return (
    <div className="rounded-xl border border-danger-border bg-danger-bg px-3.5 py-3 text-sm text-danger-text">
      {message}
    </div>
  );
}
